// extracted by mini-css-extract-plugin
module.exports = {"image":"Card_image__2j5MI","addToCart":"Card_addToCart__1zPWt","discountBadge":"Card_discountBadge__30xk_","goToCart":"Card_goToCart__3Zi80","background":"Card_background__Ib5G5"};